var React = require('react');

function Pin (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"style-two-pin-marker"),React.createElement("path",{"d":"M12,0A9.511,9.511,0,0,0,2.5,9.5c0,6.547,6.538,12.488,8.541,14.153a1.5,1.5,0,0,0,1.917,0c2-1.665,8.542-7.608,8.542-14.154A9.511,9.511,0,0,0,12,0Zm0,14.5a5,5,0,1,1,5-5A5,5,0,0,1,12,14.5Z","key":1})]);
}

Pin.defaultProps = {"viewBox":"0 0 24 24"};

module.exports = Pin;

Pin.default = Pin;
